var users = require("../requests/users.js").default;
var config = require('../config/settings.json');

import Vue from "vue";
import App from "../App.vue"

var date_now = new Date();
var data = {
  user:{},
  session:{
    userId:null,
    id:null,
    authenticated:false,
    ttl:null
  },
  timeout:null,
  lastUpdate:date_now
}

if(localStorage.getItem('data')){
  data = JSON.parse(localStorage.getItem('data'));
  if(!data.lastUpdate) data.lastUpdate = new Date();

  // Remettre un timeout pour la déco automatique. Calculer le temps restant du token.
  var created_at = new Date(data.session.created);
  var now = new Date();
  var msDiff = now - created_at;
  var ttl = data.session.ttl*1000; // Pour mettre en ms.
  var timeout = ttl - msDiff;
  if(timeout > 0){
    data.timeout = setTimeout(function(){
      App.methods.logout();
    },(timeout));
  }
}

export default {
  data: data,
  refreshToken(ctx){
    // Ajouter 1h au timeout s'il n'a pas déjà était update il y a moins de 1h
    var now = new Date();

    // On update seulement si le TTL n'a pas déjà était mise à jour dans l'heure.
    var msDiffLastUpdate = now - new Date(this.data.lastUpdate);
    if(msDiffLastUpdate >= (config.refreshToken*1000)){   //3600 sec = 1h min soit 3600000 ms.
      this.data.lastUpdate = now;
      var parent = this;
      var newTTL = 3*config.refreshToken; // 3600sec = 1h ! *3 On remet la durée du token à 3h.
      console.log("UPDATE TOKEN");
      users.updateToken(ctx,newTTL,function(accessToken,err){
        if(err) {
          console.log("ERR REFRESH TOKEN",err);
          App.methods.logout();
        }
        else{
          parent.data.session.ttl = accessToken.ttl;
          var ttl = (parent.data.session.ttl)*1000; // Pour mettre en ms.
          // var created_at = new Date(parent.data.session.created);
          // var msDiff = now - created_at;
          // var timeout = ttl - msDiff;
          if(ttl > 0){
            clearTimeout(parent.data.timeout);
            parent.data.timeout = setTimeout(function(){
              App.methods.logout();
            },(ttl));
          }
          localStorage.setItem('data', JSON.stringify(parent.data));
        }
      })
    }
  },
  login(ctx,emailOrUsername,password,callback){
    var parent = this;
    var credentials = {
      email:emailOrUsername,
      password:password
    };

    users.login(ctx,credentials,function(data,err){
      if(data){
        parent.data.session = data.session;
        parent.data.session["authenticated"] = true;
        parent.data.user = data.user;
        localStorage.setItem('data', JSON.stringify(parent.data));
        callback();
      }
      else if(err){
        // Tenter la connexion avec email = username
        credentials = {
          username:emailOrUsername,
          password:password
        }
        users.login(ctx,credentials,function(data,err){
          var msg_error = "Erreur inconnue.";
          if(data){
            msg_error = null;
            parent.data.session = data.session;
            parent.data.session["authenticated"] = true;
            parent.data.user = data.user;
            localStorage.setItem('data', JSON.stringify(parent.data));
            // parent.data.session.ttl = (data.ttl * 1000)-600000; // 600000 = -10min
            parent.data.timeout = setTimeout(function () {
              App.methods.logout();
            }, (data.session.ttl*1000));
          }
          else if(err){
            msg_error = err;
          }
          callback(msg_error);
        });
      }
      else{
        callback("Erreur inconnue.");
      }
    });
  },
  logout(){
    this.data.user = {};
    this.data.session = {
      userId:null,
      id:null,
      authenticated:false,
      ttl:null
    };
    clearTimeout(this.data.timeout);
    Vue.http.headers.common['Authorization'] = "";
    localStorage.setItem('data', JSON.stringify(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/storage/data.js